export type Language = "ko" | "en";

export interface DateRange {
  //   startDate: Date | null ;
  //   endDate: Date | null;
}

export interface DateRangePickerProps {
  label?: string;
  //   defaultStart: Date;
  //   defaultEnd: Date;
  defaultStart: string;
  defaultEnd: string;
  language?: Language;
  startNm?: string;
  endNm?: string;
  onChange?: (range: Array<string>) => void;
}

export type ViewMode = "date" | "year" | "month";

export const weekNames = {
  ko: ["일", "월", "화", "수", "목", "금", "토"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const parseYYYYMMDD = (yyyymmdd: string): Date => {
  const y = Number(yyyymmdd.slice(0, 4));
  const m = Number(yyyymmdd.slice(4, 6)) - 1;
  const d = Number(yyyymmdd.slice(6, 8));
  // 한국시간 기준
  const utc = new Date(Date.UTC(y, m, d));
  utc.setHours(utc.getHours() + 9);
  return utc;
};

export const getDaysInMonth = (year: number, month: number) =>
  new Date(year, month + 1, 0).getDate();

export const getFirstDay = (year: number, month: number) =>
  new Date(year, month, 1).getDay();

export const generateCalendar = (year: number, month: number) => {
  const days = getDaysInMonth(year, month);
  const first = getFirstDay(year, month);

  const arr: (number | null)[] = [];

  for (let i = 0; i < first; i++) arr.push(null);

  for (let i = 1; i <= days; i++) arr.push(i);

  return arr;
};

export const prevMonth = (year: number, month: number) => {
  if (month === 0) return { year: year - 1, month: 11 };

  return { year, month: month - 1 };
};

export const nextMonth = (year: number, month: number) => {
  if (month === 11) return { year: year + 1, month: 0 };

  return { year, month: month + 1 };
};

export const isSameDay = (a: Date | null, b: Date | null) => {
  if (!a || !b) return false;

  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
};

export const isInRange = (date: Date, start: Date | null, end: Date | null) => {
  if (!start || !end) return false;

  return date >= start && date <= end;
};

export const getYearRange = (year: number) => {
  const start = year - 5;

  return Array.from({ length: 11 }, (_, i) => start + i);
};

export const swapIfNeeded = (start: Date | null, end: Date | null) => {
  if (start && end && start > end) return { startDate: end, endDate: start };

  return { startDate: start, endDate: end };
};

export const isSunday = (date: Date) => date.getDay() === 0;
export const isSaturday = (date: Date) => date.getDay() === 6;
